// Mirrors finance-service EntityService fee calculations for invoice preview
const TAX_RATES = 10;
const BLOQCUBE_FEES = 0.5;

export const calculateStripeFees = (amount, paymentMethod = 'us_bank_account') => {
  const feePercentage = paymentMethod === 'us_bank_account' ? 0.8 / 100 : 2.9 / 100;
  return Math.floor(amount * feePercentage);
};

export const calculateInvoiceAmounts = (subtotal) => {
  const taxAmount = Math.floor((subtotal * TAX_RATES) / 100);
  const applicationFees = Math.floor((subtotal * BLOQCUBE_FEES) / 1000);
  const stripeFees = calculateStripeFees(subtotal + taxAmount, 'us_bank_account');
  const totalAmountDue = subtotal + taxAmount + stripeFees + applicationFees;

  return {
    subtotal,
    taxes: taxAmount,
    stripeCharges: stripeFees,
    transactionHandlingCost: applicationFees,
    totalAmountDue,
  };
};

export const getInvoiceStatusColor = (status, theme) => {
  switch (status) {
    case 'APPROVED':
      return theme.palette.success.main;
    case 'DECLINED':
      return theme.palette.error.main;
    case 'PENDING':
    default:
      return theme.palette.warning.main;
  }
};

export const getInvoiceDialogTitle = (status, isUpdate) => {
  if (!isUpdate) return 'Generate Invoice';
  if (status === 'DECLINED') return 'View Invoice';
  if (status === 'APPROVED' || status === 'AMENDED') return 'Amend Invoice';
  if (status === 'PENDING') return 'Update Invoice';
  return 'Invoice';
};

export const isInvoiceEditable = (status) => {
  return status === 'PENDING' || status === 'APPROVED' || status === 'AMENDED';
};
